import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../helpers/reducerRegistry'
import { TYPE_SORT } from '../../constant'
import { FIELD_SORT } from '../constant'
import {
  convertDataTableDownload,
  covertTypeCategory,
  getDataSizeTable,
  getListIdTableDownload,
} from '../helper'
import {
  getDownloadFile,
  getFileCategory,
  getHeaderDownloadFile,
  getTypeReportFileFormat,
} from './thunk'

const initialState = {
  data: {},
  ids: [],
  filter: {
    InputSearch: '',
    FileCategoryId: 0,
    DownLoadDateFrom: null,
    DownLoadDateTo: null,
    ExpiryDateFrom: null,
    ExpiryDateTo: null,
    Page: 1,
    PageSize: 20,
    sort: FIELD_SORT.DELIVERY_DATE,
    sortDirection: TYPE_SORT.DESCENDING,
  },
  isLoading: {
    getDownloadFile: false,
    getFileCategory: false,
    getTypeFile: false,
  },
  dataCategory: [],
  typeFile: [],
  totalItems: 0,
  totalRecords: 0,
}

const slice = createSlice({
  name: 'library/downloadedFiles',
  initialState,

  reducers: {
    resetStore(state) {
      Object.keys(initialState).forEach((key) => {
        state[key] = initialState[key]
      })
    },
    changeFilter: (state, action) => {
      state.filter = { ...state.filter, ...action.payload }
    },
    changeTotalItems: (state, action) => {
      state.totalItems = action.payload
    },
  },

  extraReducers: (builder) => {
    // get type Category getFileCategory
    builder.addCase(getFileCategory.pending, (state) => {
      state.isLoading.getFileCategory = true
    })
    builder.addCase(getFileCategory.fulfilled, (state, action) => {
      state.dataCategory = covertTypeCategory(action.payload)
      state.isLoading.getFileCategory = false
    })
    builder.addCase(getFileCategory.rejected, (state, action) => {
      state.isLoading.getFileCategory = false
    })

    //get data table download file
    builder.addCase(getDownloadFile.pending, (state, action) => {
      state.isLoading.getDownloadFile = true
    })
    builder.addCase(getDownloadFile.fulfilled, (state, action) => {
      state.ids = getListIdTableDownload(action.payload.data)
      state.data = convertDataTableDownload(action.payload.data)
      state.filter = { ...state.filter, ...getDataSizeTable(action.payload) }
      state.totalRecords = action.payload?.totalRecords
      state.isLoading.getDownloadFile = false
    })
    builder.addCase(getDownloadFile.rejected, (state, action) => {
      state.ids = []
      state.data = {}
      state.isLoading.getDownloadFile = false
    })

    // getTypeReportFileFormat
    builder.addCase(getTypeReportFileFormat.pending, (state, action) => {
      state.isLoading.getTypeFile = true
    })
    builder.addCase(getTypeReportFileFormat.fulfilled, (state, action) => {
      state.typeFile = action.payload
      state.isLoading.getTypeFile = false
    })
    builder.addCase(getTypeReportFileFormat.rejected, (state, action) => {
      state.ids = []
      state.data = {}
      state.isLoading.getTypeFile = false
    })

    //getHeaderDownloadFile
    builder.addCase(getHeaderDownloadFile.fulfilled, (state, action) => {
      state.totalItems = action.payload
    })
  },
})

//table
export const selectIds = (state) => state[slice.name].ids
export const selectDataTable = (rowId, colId) => (state) => {
  return state[slice.name].data[rowId][colId]
}

//loading export get loading
export const selectLoadingDownLoadList = (type) => (state) => {
  return type ? state[slice.name].isLoading[type] : state[slice.name].isLoading
}

//filter filter
export const selectFilter = (type) => (state) =>
  type ? state[slice.name].filter[type] : state[slice.name].filter
export const selectTypeCategory = (state) => state[slice.name].dataCategory
export const selectTotalItems = (state) => state[slice.name].totalItems
export const selectTotalRecords = (state) => state[slice.name].totalRecords
export const selectTypeFile = (state) => state[slice.name].typeFile

export const { changeFilter, resetStore, changeTotalItems } = slice.actions

register(slice.name, slice.reducer)
